<template>
  <div>
<!--    <iframe v-if="isusersession=='nosession'" id="pluginonlin" name="pluginonlin"-->
<!--            :src="`https://tool.5118.com/Pluginonline`"-->
<!--            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
<!--    <iframe v-if="isuseruserinfo=='nosession'" id="pluginonlin" name="pluginonlin"-->
<!--            :src="`https://tool.5118.com/Pluginonline`"-->
<!--            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
<!--    <iframe v-if="isplken=='nosession'" id="pluginonlin" name="pluginonlin"-->
<!--            :src="`https://tool.5118.com/Pluginonline`"-->
<!--            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe>-->
    <!-- <iframe v-if="logged" id="onlinetongji" name="onlinetongji"
            :src="`https://aiplugin.5118.com/Pluginstat/?p=UserOnline`"
            style="width: 0px; height: 0px; position: fixed; transform: translateY(-9999px);"></iframe> -->
    <Header></Header>
    <div class="content-box" :class="{'show-up-tip':showUpTip}">
      <Menu></Menu>
      <router-view class="content"></router-view>
      <Up v-if="menuList.indexOf(activeMenu)!==-1" v-show="showUp"></Up>
    </div>
  </div>
</template>

<script>
  import Menu from "../components/Menu"
  import Header from "../components/Header"
  import Up from "../components/global/Up"
  import Cookies from 'js-cookie'
  // import axios  from 'axios'
  export default {
    components: {
      Menu,
      Header,
      Up
    },
    data() {
      return {
        menuList: [
          "seobigdata",
          "outlink",
          "baidurank",
          "mousebaidurank",
          "nofollow",
          "badlink",
          "baidusite",
          "checkicp",
          "prohibitedwords",
          "sofasniper",
        ],
        isusersession:"",
        isuseruserinfo:"",
        isplken:""
      }
    },
    mounted() {
      this.get_user_data();
      this.getCookie();
      this.get_userinfo_coookies();
      this.$messenger.addTarget(window.parent, 'parent');
      this.listenBadLink();

    },
    computed: {
      activeMenu() {
        return this.$store.state.menu.name
      },
      showUp: {
        get() {
          return this.$store.state.menu.showUp
        }, set(val) {
          this.$store.state.menu.showUp = val
        }
      },
      showUpTip: {
        get() {
          return this.$store.state.header.showUpTip
        },
        set(val) {
          this.$store.state.header.showUpTip = val
        }
      },
      logged: {
        get() {
          return this.$store.state.user.logged
        },set(val){
          this.$store.state.user.logged = val
        }
      },
      userInfo: {
        get() {
          return this.$store.state.user.userInfo
        },
        set(val){
          this.$store.state.user.userInfo = val
        }
      },
      loginBox:{
        get() {
          return this.$store.state.header.loginBox
        }, set(val) {
          this.$store.state.header.loginBox = val
        }
      },
      token:{
        get() {
          return this.$store.state.menu.token
        }, set(val) {
          this.$store.state.menu.token = val
        }
      },level:{
        get() {
          return this.$store.state.menu.level
        }, set(val) {
          this.$store.state.menu.level = val
        }
      },
      apitoken:{
        get(){
          return this.$store.state.menu.apitoken;
        },
        set(val){
          this.$store.state.menu.apitoken=val;
        }
      }

    },
    methods: {
      listenBadLink() {
        //获取正常链接数
        this.$messenger.listen("_5118_Version_No", (msg) => {
          this.$store.state.menu.version = msg;
          if (msg.replace(/\./gi, '') < 201) {
            this.showUp = true;
          }
        });
        // this.$messenger.listen("_5118_Check_IsLogin_Status", (msg) => {
        //   if(this.logged){
        //     this.$messenger.addTarget(window.parent, 'parent');
        //     this.$messenger.targets['parent'].send("Show_Login_Baidu_Message","1");
        //   }
        //   else
        //   {
        //     this.$messenger.addTarget(window.parent, 'parent');
        //     this.$messenger.targets['parent'].send("Show_Login_Baidu_Message","2");
        //   }
        // });
        this.$messenger.listen("_5118_Show_Main_Login", (msg) => {
          if(this.logged){
            return
          }

          if(this.loginBox){
            this.loginBox.close();
            this.loginBox = null
          }
          this.loginBox = this.$loginBox();

        });
      },
      //获取cookies
      getCookie() {
        if (!Cookies.get('_5118_Plguin') && !localStorage.getItem('_5118_Plguin')) {
          // _hmt.push(['_trackEvent', 'User', 'New']);
          let addtime = new Date().getTime();
          Cookies.set('_5118_Plguin', addtime, {expires: 100000, path: '/'});
          localStorage.setItem('_5118_Plguin', addtime);
        }
      },
      get_userinfo_coookies() {
        // let userData={"avatar":"https://p.5118img.com/avatar/4bfbecdc8b8843c89bc574950bb6e366_269_s.jpg","uid":"5AF2F72514B9DE18","token":"3e28694c-dd2e-43d3-bdb6-82524d1755ab","level":"200","plken":"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1aWQiOjI2OSwidWd1aWQiOiIzZTI4Njk0Yy1kZDJlLTQzZDMtYmRiNi04MjUyNGQxNzU1YWIiLCJleHBpcmUiOiIyMDIyLTA3LTIzIDE2OjM3OjMzIn0.LxfNFoSxd8tL0JrSCWeC8kZgxmI0V31w7P7k4tDaHzM"}
        // Cookies.set('_5118_Plug_In_UserInfo2', JSON.stringify(userData), {expires: 100000, path: '/'});
        let userInfo = JSON.parse(Cookies.get('_5118_Plug_In_UserInfo') || "{}") || {};
        if(userInfo)this.token = userInfo.token || '';
        if(userInfo)this.level = userInfo.level || '';
        // if(userInfo)this.apitoken = userInfo.plken || '';
        this.logged = !!userInfo.avatar;
        if(userInfo){
          if(userInfo.plken){
            this.apitoken = userInfo.plken || '';
            this.isplken = this.apitoken
          }
          else{
            this.isplken="nosession"
          }
        }
        if(this.isusersession!="nosession")this.isuseruserinfo = userInfo.uid || "nosession";

        this.userInfo = userInfo
      },
      get_user_data(){
        this.isusersession = Cookies.get('_5118_Plug_In_Session') || "nosession";
      }
    }
  }
</script>

<style type="text/less" lang="less" scoped>
  @import "../assets/style/color";
  @import "../assets/style/config";
  @import "../assets/style/mixin";

  .content-box {
    width: @body-width;
    height: @body-height;
    display: flex;
    &.show-up-tip {
      height: calc(@body-height - @up-tip-height);
    }
    .content {
      overflow: auto;
      height: 100%;
      width: @content-width;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Content.vue